<template>
    <terms-dialog v-model="selected" @isLoaded="setTermsList" @input="(value) => $emit('input', value)" @isValid="(isValid) => $emit('isValid', isValid)">
        <template #activator="{ on }">
            <v-sheet v-on="on" color="mt-20 mt-lg-42">
                <v-checkbox v-model="isAllSelected" class="mb-12" label="전체 동의하기" hide-details color="primary" readonly />
                <v-card outlined rounded="lg" class="min-h-80px">
                    <div class="pa-12 pa-md-20">
                        <template v-for="item in items">
                            <v-checkbox :key="item._id" v-model="item.value" v-bind="item" hide-details readonly />
                        </template>
                    </div>
                </v-card>
            </v-sheet>
        </template>
    </terms-dialog>
</template>

<script>
import TermsDialog from "./terms-dialog.vue";

export default {
    components: {
        TermsDialog,
    },
    props: {
        value: { type: Array, default: () => [] },
    },
    data: () => ({
        termsList: [],
        selected: [],
    }),
    computed: {
        items() {
            return this.termsList.map(({ _id, necessary, subject }) => ({
                _id,
                label: `[${necessary ? "필수" : "선택"}]${subject}에 동의`,
                value: this.selected.includes(_id),
            }));
        },
        isAllSelected() {
            return !this.items.some(({ value }) => !value);
        },
    },
    methods: {
        sync() {
            this.selected = [...this.value];
        },
        setTermsList(termsList) {
            this.termsList = termsList;
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style>
</style>